import * as React from "react";

export const IconStarOutline = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="19" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.7695 7.06445L11.8818 7.41016H17.9707L13.3389 10.7754L13.0449 10.9893L13.1572 11.335L14.9258 16.7803L10.2939 13.415L10 13.2012L9.70605 13.415L5.07324 16.7803L6.84277 11.335L6.95508 10.9893L6.66113 10.7754L2.0293 7.41016H8.11816L8.23047 7.06445L10 1.61719L11.7695 7.06445Z"
      stroke="currentColor"
    />
  </svg>
);
